export const environment = {
  production: true,
 // apiUrl: 'https://athena-technologies.ch', // URL de l'API en production
  //athenaApiUrl: 'https://athena-technologies.ch'
  apiUrl: 'http://localhost:4200', // URL de l'API en développement
  athenaApiUrl: 'http://localhost:5001'
};
